import { IsString } from 'class-validator';

export class Filiacao {
  @IsString()
  nomePai: string;

  @IsString()
  nomeMae: string;
}
